import { pipe } from "callbag-basics";
import subscribe from "callbag-subscribe";
import { useEffect, useState } from "react";

import { ProgressBar } from "@livechat/design-system";
import { DesignToken, Icon, IconSource, Popover, SpacingToken, Text } from "@livechat/design-system-react-components";

import LinkStyledButton from "components/button/LinkStyledButton";
import Block from "components/layout/Block";
import Flex from "components/layout/Flex";
import { withVar } from "themes/helpers";

import { LinkBox } from "./styles";

export const DropdownContents: React.FC<{ title: React.ReactNode; icon: IconSource; children: React.ReactNode }> = ({
  title,
  icon,
  children,
}) => (
  <Flex padding={withVar(SpacingToken.Spacing3)} column gap={withVar(SpacingToken.Spacing2)} width="240px">
    <Flex alignItems="center" gap={withVar(SpacingToken.Spacing2)}>
      <Icon source={icon} size="small" customColor={withVar(DesignToken.ContentBasicPrimary)} />
      <Text bold css={{ color: withVar(DesignToken.ContentBasicPrimary) }}>
        {title}
      </Text>
    </Flex>
    {children}
  </Flex>
);

export const ActionDropdown: React.FC<{
  title: React.ReactNode;
  active: boolean;
  isVisible: boolean;
  onClick: () => void;
  onClose: () => void;
  children: React.ReactNode;
}> = ({ title, active, children, isVisible, onClick, onClose }) => (
  <Popover
    isVisible={isVisible}
    placement="bottom-start"
    onClose={onClose}
    triggerRenderer={() => (
      <LinkBox>
        <LinkStyledButton
          lineHeight="14px"
          noUnderline
          fontSize="14px"
          fontWeight={active ? "600" : "400"}
          onClick={onClick}
        >
          <Flex alignItems="center">
            {title}
            <div className="down-arrow" />
          </Flex>
        </LinkStyledButton>
      </LinkBox>
    )}
  >
    {children}
  </Popover>
);

export const DropdownWrapper = ({
  actionTitle,
  dropdownTitle,
  active,
  icon,
  children,
  isVisible,
  onClick,
  onClose,
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
}: any) => (
  <Block paddingRight="8px" margin="8px">
    <ActionDropdown title={actionTitle} active={active} isVisible={isVisible} onClick={onClick} onClose={onClose}>
      <DropdownContents title={dropdownTitle} icon={icon}>
        {children}
      </DropdownContents>
    </ActionDropdown>
  </Block>
);

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export const ActionWrapper = ({ color = "linkColor", title, onClick }: any) => (
  <Block paddingRight="8px" margin="8px">
    <LinkStyledButton color={color} lineHeight="14px" fontSize="14px" onClick={onClick} noUnderline>
      {title}
    </LinkStyledButton>
  </Block>
);

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const BulkActionProgressBar: React.FC<{ progressChannel: any; count: number }> = ({
  progressChannel,
  count,
}) => {
  const [updated, setUpdated] = useState(0);

  useEffect(() => {
    const unsubscribe = pipe(
      progressChannel,
      subscribe(() => {
        setUpdated(updated + 1);
      })
    );

    return unsubscribe;
  }, [progressChannel, setUpdated, updated]);

  const percentage = Math.min((updated / count) * 100.0, 100.0);

  return <ProgressBar percent={percentage} />;
};
